// extracted by mini-css-extract-plugin
export default {"main":"Input_main__zcjGa","label":"Input_label__wXgoT","input":"Input_input__pJFgp","error":"Input_error__OXiUT","resize":"Input_resize__t3YKy"};